import React from "react";
import { User } from '../../App';

interface Props {
    user: User
}

export default class Avatar extends React.Component<Props, { error: boolean }> {
    constructor(props: Props) {
        super(props);
        this.state = { error: false }
    }
    getDefaultUrl() {
        const pop = this.props.user.name.split('#').pop();
        console.log(pop);
        const discrim = parseInt(pop ?? "0");
        return `https://cdn.discordapp.com/embed/avatars/${discrim % 5}.png`
    }

    render() {
        const url = this.state.error
            ? this.getDefaultUrl()
            : this.props.user.avatar;

        return (
            <div className="avatar">
                <img src={url} onError={_ => this.setState({ error: true })} alt="" />
            </div>
        );
    }
}